/** Canvas 创建与 2D 上下文获取的共享工具。 */

export function createCanvas(w: number, h: number): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(w));
  c.height = Math.max(1, Math.round(h));
  return c;
}

/** 获取 2D 上下文；不支持时抛错（生产级：绝不静默返回 null）。 */
export function get2D(canvas: HTMLCanvasElement | OffscreenCanvas): CanvasRenderingContext2D {
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('无法获取 Canvas 2D 上下文（当前浏览器可能不支持）');
  return ctx as CanvasRenderingContext2D;
}
